@import '~style-sheet-helpers/core.less';
@import '../../../../../../app-brand/entities/entity-layer.module.less';
@import (reference) '../../../../../../constants/spacing.module.less';

@first-box-shadow: 0 0 0 1px @settings-page--stores-selected-checkout-edit-rate-button--focus--first-box-shadow-color;
@second-box-shadow: 0 0 0 2px @settings-page--stores-selected-checkout-edit-rate-button--focus--second-box-shadow-color;

.container {
  --section-width: 659px;

  padding: 20px 12px 20px 24px;
  overflow-y: auto;
  background-color: var(--onboarding-page--background-color);
  height: 100%;

  .percentage-input {
    width: 90px;
  }

  > h2 {
    margin: 0 0 4px;
    font-weight: @normal;
    line-height: 1.25;
  }
}

.define-page-description {
  font-size: 14px;
  line-height: 1.5;
  max-width: 700px;
}

.footer {
  max-width: 700px;
  padding-top: 12px;
  > Button,
  span {
    margin-right: 10px;
  }
}

.edit-delivery-options-section {
  margin: 24px 0 0;
}

.section-title {
  font-size: 14px;
  font-weight: @bold;
  margin-bottom: 8px;
  display: flex;
  flex-direction: column;
}

.error {
  color: @settings-page--stores-selected-checkout-edit-title--error--text-color;
}

.rate-adjustment-title {
  font-size: 20px;
  margin-bottom: 4px;
}

.section-subtitle {
  font-size: 12px;
  line-height: 1.5;
  max-width: 610px;
  display: flex;
}
.service-subtitle {
  font-size: 12px;
  line-height: 1.5;
}

.section-controls {
  max-width: 352px;
  &:not(:last-child) {
    padding-bottom: 12px;
  }
  &.description {
    max-width: 550px;
  }
}

.service-list {
  max-width: 352px;
}

.single-local-delivery-service-name {
  font-size: 14px;
}

.section-control-dropdown-menu {
  font-size: 14px;

  .section-control-dropdown-button {
    height: 32px;
    width: 352px;
  }

  .rate-adjustment-dropdown-button {
    height: 32px;
    width: 207px;
  }
}

.live-rate-section {
  position: relative;
  z-index: 1;
  &:not(:last-child) {
    margin-bottom: 12px;
  }

  &.service-dropdown-section {
    z-index: 2;
  }
}

.service-title {
  font-size: 14px;
  font-weight: @bold;
  margin: 8px 0 4px;
}

.live-rate-title {
  font-size: 14px;
  font-weight: @bold;
  margin: 8px 0;
}

.adjustment-title {
  font-size: 14px;
  font-weight: @bold;
  margin: 16px 0 8px;
}

.fees-radio-buttons {
  > * {
    padding: 0 0 8px;
  }
}

.additional-fee-row {
  font-size: 14px;
  > * {
    margin-right: 4px;
  }

  &:not(:last-child) {
    margin-bottom: 12px;
  }
}

.currency-input {
  margin: 8px 0;
  border: 1px solid @settings-page--stores-selected-checkout-edit-input--border-color;
  width: 90px;
  height: 40px;
}

.fallback-options-percentage-controls {
  font-size: 14px;
  display: flex;
  align-items: center;
  > * {
    margin-right: 4px;
  }
}

.fallback-warning {
  width: fit-content;
}

.services-error {
  padding-top: 4px;
  max-width: 264px;
}

.pickup-settings-schedule {
  font-size: 12px;
  display: grid;
  grid-template-columns: 50px 150px;
  align-items: start;
  row-gap: 5px;
  margin-bottom: 5px;
}

.pickup-settings-schedule-timezone {
  font-size: 12px;
}

.additional-fees-controls {
  margin: 0 0 8px 24px;
  padding: 8px 0 16px 12px;
  background-color: @settings-page--stores-selected-checkout-edit-charge-fee--background-color;
  border: 1px solid @settings-page--stores-selected-checkout-edit-charge-fee--border-color;
  border-radius: 4px;
  max-width: 600px;
}

.additional-fees-input-container {
  display: flex;
  align-items: center;
  > .currency-input,
  .percentage-input {
    margin: 0 12px 0 0;
    font-style: italic;
  }
}

.rate-type-button-container {
  display: flex;
  align-items: stretch;
  margin-bottom: 12px;

  width: var(--section-width);
  max-width: var(--section-width);

  gap: 24px;

  > Button {
    display: flex;
    flex-direction: column;
    align-items: center;

    flex: 1;
    height: unset;

    padding: 8px;
    border-radius: 8px;
    &:hover {
      background: @settings-page--stores-selected-checkout-edit-rate-button--hover--background-color;
      border: 1px solid @settings-page--stores-selected-checkout-edit-rate-button--hover--border-color;
      cursor: pointer;
    }
    &:focus {
      background: @settings-page--stores-selected-checkout-edit-rate-button--focus--background-color;
      border: 1px solid @settings-page--stores-selected-checkout-edit-rate-button--focus--border-color;
      box-shadow: @first-box-shadow, @second-box-shadow;
    }
    &.selected {
      border: 2px solid @settings-page--stores-selected-checkout-edit-rate-button--selected--border-color;
      padding: 7px;
    }
    &.calc-button {
      max-width: 192px;
    }
  }
}

.rate-type-name {
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 4px;
  text-align: left;
  width: 100%;
}

.rate-type-description {
  font-size: 12px;
  line-height: 16px;
  text-align: left;
}

.check {
  color: @settings-page--stores-selected-checkout-edit-check--text-color;
  height: 15px;
  width: 15px;
  padding: 2px;
  margin-top: @space-12;
}

.breakpoint-container {
  border-radius: 4px;
  border: 1px solid @shipping--default--border-color-light;
  width: 743px;
  padding: @space-16;
  align-self: center;
  background-color: var(--setup-page--right--background-color);
  &.read-only {
    margin-bottom: @space-16;
    color: var(--default--text-color--15);
    width: 100%;
  }
}

.dim-gap {
  margin-left: 32px;
}

.dimensions-section-subtitle {
  font-size: 12px;
  line-height: 1.5;
  max-width: 610px;
  margin-bottom: @space-16;
}

.dimension-input {
  width: 106px;
}

.weight-input {
  width: 75px;
}

.package-text {
  flex: 1;
}
.dimension-container {
  display: flex;
}

.external-link-icon {
  height: @space-12;
  width: @space-12;
  margin-left: @space-4;
}
.error-icon {
  height: @space-16;
  width: @space-16;
  margin-right: @space-8;
  color: var(--inline-message--error--text-color);
}

.popover-footer {
  display: flex;
  align-items: baseline;
  margin-top: @space-12;
  gap: @space-12;
}

.help-link {
  > div {
    display: flex;
    align-items: center;
  }
}
.title-container {
  display: flex;
  flex-direction: column;
  margin-bottom: @space-16;
}

.banner-info {
  padding: 4px 8px;
  margin-top: @space-16;
}

.deactived-banner {
  padding: 12px;
}

.calc-button {
  width: 169px;
}

.weight-text {
  margin-top: @space-8;
  margin-right: @space-8;
}

.delete-button {
  color: var(--onboarding-page--refresh-icon--fill-color);
  height: 16px;
  width: 16px;
}
.delete-button:hover {
  color: var(--setup-page--loading-indicator-color);
}

.info-icon {
  margin-bottom: @space-4;
  margin-left: @space-8;
  cursor: pointer;
  color: @primary-button--background-color;
  height: @space-16;
  width: auto;
  vertical-align: middle;
}

.weight-error {
  background-color: @banner-message--error--background-color;
  margin-top: @space-8;
  padding: @space-8;
  font-size: 14px;
}

.start-stop {
  font-size: 12px;
  line-height: 24px;
}

.start-stop-container {
  margin-top: @space-8;
  display: flex;
  justify-content: space-between;
  &.read-only {
    gap: @space-12;
  }
}

.dimensions-gap {
  gap: @space-4;
}

.unit-margin {
  margin-right: @space-16;
}

.add-button {
  height: @space-32;
}

.card-section-title {
  font-size: @space-24;
  line-height: 32px;
}

.section-info {
  margin-bottom: @space-16;
  font-size: 14px;
  line-height: @space-24;
}

.section-container {
  background-color: var(--default--background-color-22);
  padding: 16px;
  width: var(--section-width);
  max-width: var(--section-width);
  margin-bottom: @space-16;
  border: 1px solid var(--grey-300);
  border-radius: 4px;

  .rate-type-button-container {
    width: calc(var(--section-width) - 32px);
    max-width: calc(var(--section-width) - 32px);
  }
}

.required {
  font-size: 12px;
  font-weight: 400;
  margin-left: @space-4;
  color: var(--default--text-color--15);
}

.popover-target {
  height: 100px;
}

.disabled-pop-over {
  border: 1px solid @settings-page--stores-selected-checkout-preview--border-color;
  border-radius: 8px;
  background: @settings-page--stores-selected-checkout-preview--background-color;
  align-items: center;
  font-size: 12px;
  display: flex;
  flex-direction: column;
  max-width: 192px;
  height: 100%;
  padding: @space-8;
}

.pop-over-button {
  font-size: 12px;
}

.edit-icon {
  display: flex;
  justify-content: space-between;
}

.empty-div {
  flex: 1;
}

.icon-container {
  display: inline;
}

.range-header {
  display: flex;
  justify-content: space-between;
}
.range-header-read-only {
  gap: @space-12;
}

.rate-container-margin {
  margin-bottom: @space-24;
}
.status-text {
  font-size: 14px;
  line-height: 18px;
}

.dims-modal {
  margin-top: @space-24;
}

.fallback-dropdown {
  font-weight: 500;
  margin-bottom: @space-8;
}

.modal-info-container {
  margin-top: @space-8;
  margin-bottom: @space-24;
}

.modal-body {
  display: flex;
  flex-direction: column;
  &:last-child {
    margin-bottom: @space-32;
  }
}

.header-text {
  display: flex;
}

.header-text-read-only {
  display: flex;
  flex: 1;
}

.dashed-line {
  border-right: 1px dashed var(--default--icon--fill-color--12);
  height: 64px;
  width: 50%;
}

.add-range-button {
  position: absolute;
  right: calc(50% - 64px);
  width: 128px;
  text-align: center;
  height: 24px;
  margin-top: 20px;
}

.range-button {
  background-color: var(--white);
  padding: @space-4;
  &:focus {
    background-color: var(--white);
  }
}

.dashed-hortizontal-line {
  border-top: 1px dashed var(--default--icon--fill-color--12);
  margin-top: 40px;
  width: 80px;
  margin-right: @space-8;
  &.is-read-only {
    margin-top: 18px;
  }
}

.weight-range {
  position: absolute;
  right: calc(50% - 64px);
  width: 128px;
  text-align: center;
  height: 24px;
  margin-top: 20px;
}

.weight-container {
  display: flex;
  flex: 1;
}

.dim-label {
  margin-top: @space-8;
  &.left-margin {
    margin-left: @space-8;
  }
}

.dim-label-read-only {
  margin-top: @space-8;
  flex: 1;
}

.pen-icon {
  width: 16px;
  height: 16px;
  margin-right: @space-4;
}

.arrow {
  width: 91px;
  margin-left: @space-4;
}

.line {
  margin-top: @space-16;
  width: 74px;
  background-color: var(--default--text-color--15);
  height: 1px;
  float: left;
  &.edit-mode {
    margin-top: 40px;
  }
}

.point {
  width: 0;
  height: 0;
  border-top: 4px solid transparent;
  border-bottom: 4px solid transparent;
  border-left: 7px solid var(--default--text-color--15);
  float: right;
  margin-right: 10px;
  margin-top: @space-12;
  &.edit-mode {
    margin-top: @space-36;
  }
}
